import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { KeyValue } from '@angular/common';

import { Subscription } from 'rxjs';

import { ToolAdapterService } from '../../tools/tool-adapter.service';
import { DrawToolService } from '../../tools/draw-tool.service';
import { SpecificationHelperService } from '../../services/specification-helper.service';
import { SharedService } from '../../services/shared.service';

import { ControlSpecification } from '../../types/specification.types';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dy-tool-box',
  templateUrl: './tool-box.component.html',
  styleUrls: ['./tool-box.component.css']
})
export class ToolBoxComponent implements OnInit, OnDestroy {
  @Input() disableOperateControl: boolean;
  @Output() showFormProperty: EventEmitter<boolean> = new EventEmitter();

  controlGroups: Array<KeyValue<string, Array<ControlSpecification>>> = [];
  changeToFormActive: boolean = false;

  get selectToolSelected(): boolean {
    const tool = <DrawToolService>this.toolAdapter.currentTool;
    return tool !== undefined && tool !== null && tool.specification === undefined;
  }

  private changeToSelectToolSubscription: Subscription;
  constructor(
    private toolAdapter: ToolAdapterService,
    private specificationHelperService: SpecificationHelperService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.groupControlSpecification();
    this.changeToSelectToolSubscription = this.sharedService.getChangeToSelectTool$().subscribe(() => {
      this.changeToFormActive = false;
      this.showFormProperty.emit(this.changeToFormActive);
    });
  }

  ngOnDestroy(): void {
    if (this.changeToSelectToolSubscription) {
      this.changeToSelectToolSubscription.unsubscribe();
    }
  }

  private groupControlSpecification() {
    const controlGroups: Array<KeyValue<string, Array<ControlSpecification>>> = [];
    const defaultControlSpecifications = this.specificationHelperService.getControlSpecifications();
    defaultControlSpecifications.forEach((s) => {
      const groupName = s.groupName;
      const filteredGroups = controlGroups.filter((x) => x.key === groupName);
      let items: Array<ControlSpecification>;

      if (filteredGroups.length === 0) {
        const groupItem = {
          key: groupName,
          value: new Array<ControlSpecification>()
        };
        controlGroups.push(groupItem);
        items = groupItem.value;
      } else {
        items = filteredGroups[0].value;
      }

      items.push(s);
    });

    this.controlGroups.splice(0, this.controlGroups.length);
    this.controlGroups.push(...controlGroups);
  }

  changeToSelectTool() {
    this.toolAdapter.startSelect();
  }
  changeToForm() {
    this.toolAdapter.reset();
    this.changeToFormActive = true;
    this.showFormProperty.emit(this.changeToFormActive);
  }
}
